import { ClearDebtUpdateData } from '@/components/ClearDebtComp/type';
import { CouponData } from '@/interface/KKC/coupon';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// byClaude-start
/**
 * @author byClaude
 * UnionPage 贷款确认页数据缓存
 * 用于在跳转绑卡等页面时保存用户已选择的贷款数据
 */
interface UnionLoanCacheState {
  // 提现数据
  cashoutAmount?: number;
  cashoutBankCards?: any[];

  // 期数
  loanMaturity?: number;

  // 还款日
  divRepaymentTime?: string;

  // 选中券
  selectedCoupon?: CouponData | null;

  // 借新还旧数据
  clearDebtData?: ClearDebtUpdateData;

  // 清卡数弹窗
  clearCardCompVisible?: boolean;

  // 清数服务开关
  isCheckDcSwitch?: boolean;
}

const initialState: UnionLoanCacheState = {
  cashoutAmount: undefined,
  cashoutBankCards: undefined,
  loanMaturity: undefined,
  divRepaymentTime: undefined,
  selectedCoupon: undefined,
  clearDebtData: undefined,
  isCheckDcSwitch: undefined,
  clearCardCompVisible: undefined,
};

const unionLoanCacheSlice = createSlice({
  name: 'unionLoanCache',
  initialState,
  reducers: {
    setUnionLoanCache: (state, action: PayloadAction<Partial<UnionLoanCacheState>>) => ({
      ...state,
      ...action.payload,
    }),
    clearUnionLoanCache: () => initialState,
  },
});

export const { setUnionLoanCache, clearUnionLoanCache } = unionLoanCacheSlice.actions;
export default unionLoanCacheSlice.reducer;
// byClaude-end
// Contains claude-generated edits.
